import { Theme } from "@mui/material";

import { lightOrDark } from "@app/embedded/theme/utils";

import { gray } from "../../common/theme/colors";
import { rem, round } from "../../common/theme/utils";

export const defaults = {};

const MuiFormLabel = (theme: Theme) => ({
  styleOverrides: {
    root: {
      color: gray[500],
      display: "flex",
      alignItems: "center",
      minHeight: 24,
      fontFamily: ['"Work Sans"', "sans-serif"].join(","),
      fontSize: rem(13),
      fontWeight: 500,
      lineHeight: round(16 / 13),
      "&.Mui-error, &.Mui-focused": {
        color: `${gray[500]}`,
      },
      [theme.breakpoints.up("md")]: {
        fontSize: rem(13),
        lineHeight: round(16 / 13),
      },
    },
    filled: {
      color: gray[500],
    },
  },
});

const MuiFormHelperText = () => ({
  styleOverrides: {
    root: {
      color: gray[500],
      marginLeft: 0,
    },
  },
});

const MuiOutlinedInput = (theme: Theme) => ({
  styleOverrides: {
    notchedOutline: {
      border: `1px solid ${theme.palette.shades.neutral[200]}`,

      borderRadius: 6,
      ".Mui-focused input:focus ~ &": {
        border: "2px solid #4462EF",
        filter: "drop-shadow(0px 0px 6px rgba(68, 98, 239, 0.25))",
      },
    },
    root: {
      "&:hover:not(.Mui-focused):not(.Mui-disabled) > .MuiOutlinedInput-notchedOutline":
        {
          border: `1px solid ${theme.palette.shades.neutral[400]}`,
        },
    },
    input: {
      padding: "7px 19px 7px 14px",
      fontFamily: ['"Work Sans"', "sans-serif"].join(","),
      fontWeight: 400,
      fontSize: rem(16),
      lineHeight: round(32 / 18),
      "&::placeholder": {
        color: lightOrDark(
          theme.palette.shades.neutral[400],
          theme.palette.shades.neutral[200]
        )(theme),
      },
    },
  },
});

const forms = (theme: Theme) => ({
  components: {
    MuiFormLabel: MuiFormLabel(theme),
    MuiFormHelperText: MuiFormHelperText(),
    MuiOutlinedInput: MuiOutlinedInput(theme),
  },
});

export default forms;
